import { useEffect } from "react";

export function useGlobalKeyListener(
  key: string,
  callback: () => void,
  dependencies: Array<unknown>,
  isActive: boolean,
) {
  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.key === key) {
        e.stopPropagation();

        callback();
      }
    };

    if (isActive) {
      window.addEventListener("keydown", listener);

      return () => {
        window.removeEventListener("keydown", listener);
      };
    }
  }, [dependencies, isActive]);
}
